module.exports = __webpack_public_path__ + "static/it_services__home2-a26964ca14e3f34de4387efa3504ee91.jpg";